var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Template' : 'Add Template',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "1000px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "top"
    }
  }, [!_vm.dataForm.id ? _c('el-form-item', {
    attrs: {
      "label": "Copy From"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select an existing data to copy"
    },
    on: {
      "change": _vm.copyFromChange
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, _vm._l(_vm.templateList, function (item, index) {
    return _c('el-option', {
      key: "template-".concat(index, "-").concat(item.id),
      attrs: {
        "label": "".concat(item.title, "-").concat(item.subject),
        "value": item.id
      }
    });
  }), 1)], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Title",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "title", $$v);
      },
      expression: "dataForm.title"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Subject",
      "prop": "subject"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Subject",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "subject", $$v);
      },
      expression: "dataForm.subject"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Body",
      "prop": "body"
    }
  }, [_c('el-editor', {
    attrs: {
      "height": 450
    },
    model: {
      value: _vm.dataForm.body,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "body", $$v);
      },
      expression: "dataForm.body"
    }
  })], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }